var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_vm.form.filters.analitico ? _c('div', [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "GRE",
      "dense": "",
      "outlined": "",
      "item-text": "nome",
      "item-value": "codigo",
      "items": _vm.form.lists.listaGerenciasRegionais
    },
    on: {
      "change": function ($event) {
        return _vm.atualizarEscolasPorGre(_vm.form.filters.greIdAnalitico);
      }
    },
    model: {
      value: _vm.form.filters.greIdAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "greIdAnalitico", $$v);
      },
      expression: "form.filters.greIdAnalitico"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Escola",
      "dense": "",
      "outlined": "",
      "item-text": "nome",
      "item-value": "codigo",
      "items": _vm.form.lists.listaEscolas
    },
    on: {
      "focus": _vm.validarSeTemGre
    },
    model: {
      value: _vm.form.filters.escolaIdAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "escolaIdAnalitico", $$v);
      },
      expression: "form.filters.escolaIdAnalitico"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Formação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.formacaoAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "formacaoAnalitico", $$v);
      },
      expression: "form.filters.formacaoAnalitico"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Início",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataInicioAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicioAnalitico", $$v);
      },
      expression: "form.filters.dataInicioAnalitico"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataFimAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFimAnalitico", $$v);
      },
      expression: "form.filters.dataFimAnalitico"
    }
  }), _c('sigfoco-switch-button', {
    attrs: {
      "cols": 2,
      "label": "Tipo de Relatório",
      "labelChecked": "Analítico",
      "labelUnchecked": "Sintético"
    },
    model: {
      value: _vm.form.filters.analitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "analitico", $$v);
      },
      expression: "form.filters.analitico"
    }
  })], 1)], 1) : _c('div', [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "GRE",
      "dense": "",
      "outlined": "",
      "item-text": "nome",
      "item-value": "codigo",
      "items": _vm.form.lists.listaGerenciasRegionais
    },
    on: {
      "change": function ($event) {
        return _vm.atualizarEscolasPorGre(_vm.form.filters.greIdSintetico);
      }
    },
    model: {
      value: _vm.form.filters.greIdSintetico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "greIdSintetico", $$v);
      },
      expression: "form.filters.greIdSintetico"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Escola",
      "dense": "",
      "outlined": "",
      "item-text": "nome",
      "item-value": "codigo",
      "items": _vm.form.lists.listaEscolas
    },
    on: {
      "focus": _vm.validarSeTemGre
    },
    model: {
      value: _vm.form.filters.escolaIdSintetico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "escolaIdSintetico", $$v);
      },
      expression: "form.filters.escolaIdSintetico"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Carga Horária Total",
      "outlined": "",
      "inputmode": "numeric",
      "dense": "",
      "maxle": "",
      "maxlength": "5"
    },
    on: {
      "keypress": _vm.$validarEntradaNumericaComVirgula
    },
    model: {
      value: _vm.form.filters.cargaHorariaSintetico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "cargaHorariaSintetico", $$v);
      },
      expression: "form.filters.cargaHorariaSintetico"
    }
  })], 1), _c('sigfoco-switch-button', {
    attrs: {
      "cols": 2,
      "label": "Tipo de Relatório",
      "labelChecked": "Analítico",
      "labelUnchecked": "Sintético"
    },
    model: {
      value: _vm.form.filters.analitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "analitico", $$v);
      },
      expression: "form.filters.analitico"
    }
  })], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Início",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataInicioSintetico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicioSintetico", $$v);
      },
      expression: "form.filters.dataInicioSintetico"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataFimSintetico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFimSintetico", $$v);
      },
      expression: "form.filters.dataFimSintetico"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": _vm.buscarRelatorios
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": _vm.resetForm
    }
  })], 1)], 1)]), _vm.form.mostrarAnalitico ? _c('v-data-table', {
    staticClass: "mt-5 printable",
    attrs: {
      "headers": _vm.getFilteredHeader(_vm.headersAnalitico),
      "items": _vm.form.lists.listRelatorioAnalitico,
      "items-per-page": _vm.form.itemsPerPage,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.gre`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.gre) + " ")];
      }
    }, {
      key: `item.nomeEscolaComInep`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.nomeEscolaComInep) + " ")];
      }
    }, {
      key: `item.formacao`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.formacao) + " ")];
      }
    }, {
      key: `item.cargaHoraria`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.cargaHoraria) + " ")];
      }
    }], null, true)
  }) : _c('v-data-table', {
    staticClass: "mt-5 printable",
    attrs: {
      "headers": _vm.getFilteredHeader(_vm.headersSintetico),
      "items": _vm.form.lists.listRelatorioSintetico,
      "items-per-page": _vm.form.itemsPerPage,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.gre`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(item.gre) + " ")];
      }
    }, {
      key: `item.escola`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_vm._v(" " + _vm._s(item.escola) + " ")];
      }
    }, {
      key: `item.cargaHorariaTotal`,
      fn: function (_ref7) {
        var item = _ref7.item;
        return [_vm._v(" " + _vm._s(item.cargaHorariaTotal) + " ")];
      }
    }, {
      key: `item.quantidadeFormacoes`,
      fn: function (_ref8) {
        var item = _ref8.item;
        return [_vm._v(" " + _vm._s(item.quantidadeFormacoes) + " ")];
      }
    }, {
      key: `item.quantidadeDeParticipantesPrevista`,
      fn: function (_ref9) {
        var item = _ref9.item;
        return [_vm._v(" " + _vm._s(item.quantidadeDeParticipantesPrevista) + " ")];
      }
    }, {
      key: `item.quantidadeDeParticipantesPresentes`,
      fn: function (_ref0) {
        var item = _ref0.item;
        return [_vm._v(" " + _vm._s(item.quantidadeDeParticipantesPresentes) + " ")];
      }
    }, {
      key: `item.quantidadeDeParticipantesAusentes`,
      fn: function (_ref1) {
        var item = _ref1.item;
        return [_vm._v(" " + _vm._s(item.quantidadeDeParticipantesAusentes) + " ")];
      }
    }], null, true)
  }), _vm.form.lists.listRelatorioAnalitico.length > 0 || _vm.form.lists.listRelatorioSintetico.length > 0 ? _c('sigfoco-buttons', {
    attrs: {
      "actionText": "Baixar PDF",
      "cancelText": "Baixar CSV"
    },
    on: {
      "click": _vm.baixarRelatorioPdf,
      "cancel": _vm.baixarCSVRelatorio
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }